import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const PreviewModeBanner = () => {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [isPreviewMode, setIsPreviewMode] = useState(false);

  useEffect(() => {
    const checkPreview = () => {
      setIsPreviewMode(!!sessionStorage.getItem('hibff_preview_mode'));
    };
    checkPreview();
    const interval = setInterval(checkPreview, 5000);
    return () => clearInterval(interval);
  }, []);

  const exitPreview = useCallback(async () => {
    const adminToken = sessionStorage.getItem('hibff_admin_token_backup');
    if (adminToken) {
      const wasLocalStorage = sessionStorage.getItem('hibff_admin_storage_type') === 'local';
      if (wasLocalStorage) {
        localStorage.setItem('hibff_auth_token', adminToken);
        sessionStorage.removeItem('hibff_auth_token');
      } else {
        sessionStorage.setItem('hibff_auth_token', adminToken);
        localStorage.removeItem('hibff_auth_token');
      }
      sessionStorage.removeItem('hibff_admin_token_backup');
      sessionStorage.removeItem('hibff_admin_storage_type');
      sessionStorage.removeItem('hibff_preview_mode');
      try {
        await refreshUser();
      } catch {}
    }
    setIsPreviewMode(false);
    navigate('/school');
  }, [navigate, refreshUser]);

  if (!isPreviewMode) return null;

  // Render nothing here — the back button is placed inside the Sidebar instead
  return null;
};

// Exported separately so Sidebar can use it
export const useExitPreview = () => {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  return useCallback(async () => {
    const adminToken = sessionStorage.getItem('hibff_admin_token_backup');
    if (adminToken) {
      const wasLocalStorage = sessionStorage.getItem('hibff_admin_storage_type') === 'local';
      if (wasLocalStorage) {
        localStorage.setItem('hibff_auth_token', adminToken);
        sessionStorage.removeItem('hibff_auth_token');
      } else {
        sessionStorage.setItem('hibff_auth_token', adminToken);
        localStorage.removeItem('hibff_auth_token');
      }
      sessionStorage.removeItem('hibff_admin_token_backup');
      sessionStorage.removeItem('hibff_admin_storage_type');
      sessionStorage.removeItem('hibff_preview_mode');
      try {
        await refreshUser();
      } catch {}
    }
    navigate('/school');
  }, [navigate, refreshUser]);
};

export default PreviewModeBanner;
